import { mapGetters } from 'vuex';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
import format from '@/common/utilities/format';

export default{
    name: 'marketTrendsChart',
    components:{
        mvtChart
    },
    props: {
        metricDetail: {
            type: Object,
            default: null
        },
        comparedCity: {
            id: String,
            name: String
        },
        filterType : {
            type: String,
            default : "all"
        },
        selectedTimePeriod: {
            type: String,
            default: null
        },
        isCompareCity : {
            type: Boolean,
            default: false
        },
        widgetOptions: {
          type: Object,
          default: null
        }
    },
    data(){
        return{
            chartData: null,
            filterBy: 'L2Y',
        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        getChartData() {
            return this.chartData
        },
        pageData() {
            return this.glb.pageData;
        },
    },
    watch: {
        comparedCity: function(){
              this.fetchMarketChartData()
        },
        metricDetail: function(){
            this.fetchMarketChartData()
        },
        filterType: function(){
            this.fetchMarketChartData()
        },
        selectedTimePeriod: function(){
            this.filterBy = this.selectedTimePeriod;
            this.fetchMarketChartData()
        }
    },
    methods:{
        toggleData(value){
            this.filterBy = value;
            this.fetchMarketChartData()
        },
        fetchMarketChartData() {
            const currentId = this.widgetOptions && this.widgetOptions.data ? this.widgetOptions.data.currentId : this.pageData.currentId;
            const pageType = this.widgetOptions && this.widgetOptions.data ? this.widgetOptions.data.widgetType : this.pageData.pageType;
            if(!this.isCompareCity || this.metricDetail.id && this.filterType && this.comparedCity.id){
                let that = this;
                const data = {
                    metric: this.metricDetail.id,
                    timeperiod: this.filterBy,
                    currentId,
                    comparedId: this.comparedCity ? this.comparedCity.id : null,
                    listingtype: this.filterType,
                    pageType
                }
                const urlParams = new URLSearchParams(data)
                fetch(`${this.glb.appUrl}api/markettrends/compareddatabypagetype/?${urlParams}`).then(response => response.json()).then(res => {
                    if (res) {
                        res.currentData = that.getAccurateData(res.currentData);
                        if(res.currentData.length) {
                            if(that.isCompareCity) {
                                res.comparableData = that.getAccurateData(res.comparableData);
                                if(!res.comparableData) {
                                    that.chartData = null
                                    return;
                                }
                            }
                            that.populateChartData(res)
                        }
                    }
                })
            }
        },
        getAccurateData(data) {
            return (data && data.length) ? data.filter(ele=> {
                if(ele.monthYear) {
                    let monYrArr = ele.monthYear.split('/');
                    let year = parseInt(monYrArr[0])
                    let month = parseInt(monYrArr[1])
                    return (year == 2023 && [6,7,8,9,10,11,12].indexOf(month) >= 0) || year >= 2024;
                }
            }) : []
        },
        populateChartData(res){
            const labels = this.getChartLabel(res.currentData)
            const currentValues = this.getSpecificMetricData(res.currentData)

            let datasets = [
                {
                    label: this.isCompareCity ? this.pageData.blueDisplayName : this.metricDetail.metric_title,
                    data: currentValues,
                    fill: false,
                    borderColor: '#0E6959',
                    backgroundColor: '#0E6959',
                    borderWidth: 2,
                },
            ];
            if(this.isCompareCity) {
                const comparableValues = this.getSpecificMetricData(res.comparableData)
                if(comparableValues.length > 0) {
                    datasets.push({
                        label:this.comparedCity.name,
                        data: comparableValues,
                        fill: false,
                        borderColor: '#FBC02D',
                        backgroundColor: '#FBC02D',
                        borderWidth: 2
                    })
                    this.$emit('headerData', this.getFormattedValue(comparableValues[comparableValues.length - 1]))
                }
            }

            this.chartData =  {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        onClick: (e) => e.stopPropagation()
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: this.getTicks()
                        }],
                        xAxes: [{
                            display: true
                        }]
                    },
                    tooltips: {
                        enabled: true,
                        titleAlign: 'center',
                        callbacks: {
                            label: (tooltipItems, data) => {
                                const prefix = (this.metricDetail.id === 'medianlistprice' || this.metricDetail.id === 'medianpricepersqft') ? '$' : '';
                                const cityName = data.datasets && data.datasets[tooltipItems.datasetIndex] ? data.datasets[tooltipItems.datasetIndex].label + ' ' : '';
                                return `${cityName}${prefix}${format.formatNumberByComma(tooltipItems.value)}`;
                            }
                          }
                    }
                }
            };

        },
        getTicks() {
            const prefix = (this.metricDetail.id == 'medianlistprice' || this.metricDetail.id == 'medianpricepersqft') ? '$' : ''
            return {
                // beginAtZero: true,
                precision: 0,
                userCallback: function(value, index, values) {
                    return prefix ? prefix + format.friendlyPrice(value) : value
                }
            };
        },
        getChartLabel(data) {
            return data.map(ele=> {
                let date = ele.monthYear.split("/");
                return this.getFormattedDate(new Date(parseInt(date[0]), parseInt(date[1] - 1)))
            });
        },
        getSpecificMetricData(data) {
            return data ? data.map(ele=>ele.dataOfSpecificMetric) : [];
        },
        getFormattedDate(date) {
            return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`
        },
        getFormattedValue(value){
            const prefix = (this.metricDetail.id == 'medianlistprice' || this.metricDetail.id == 'medianpricepersqft') ? '$' : ''
            let val = '';
            if(value && !Number.isNaN(value * 1)){
                val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return `${prefix}${val}`;
        }
    },
    mounted(){
        this.filterBy = this.selectedTimePeriod || this.filterBy;
        this.toggleData(this.filterBy);
    }
}